import BenefitTierItem from '@activities/tier/TierBenefitsBottomSheet/BenefitTierItem';
import Button from '@components/Button';
import Column from '@components/Column';
import Loading from '@components/Loading';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useTierBenefits from './hooks/useTierBenefits';

declare module '@stackflow/config' {
    interface Register {
        TierBenefitsBottomSheet: {};
    }
}

const TierBenefitsBottomSheet: ActivityComponentType<'TierBenefitsBottomSheet'> = () => {
    const { t } = useTranslation('tier');
    const benefits = useTierBenefits();
    const { pop } = useFlow();
    return (
        <BottomSheet>
            <Title>
                <Text size='title' fontWeight='bold'>{t('tierBenefits.title')}</Text>
            </Title>
            {benefits.isFetching && (
                <Loading size='small'/>
            )}
            <Contents spacing={10}>
                {benefits?.tiers?.map((tier) => (
                    <BenefitTierItem tier={tier}
                        key={tier.tierId}
                        period={benefits?.period}
                        accumulationType={benefits!.accumulationType!} />
                ))}
            </Contents>
            <Footer>
                <Button fullWidth onClick={pop}>
                    {t('tierBenefits.close')}
                </Button>
            </Footer>
        </BottomSheet>
    );
};

const Title = styled.div`
    padding: 20px 0;
    width: 100%;
    display: flex;
    justify-content: center;
`;

const Contents = styled(Column)`
    padding: 0 16px;
    max-height: calc(80vh - 100px);
    overflow-y: auto;
`;

const Footer = styled.div`
    padding: 16px 16px calc(16px + var(--safe-area-bottom));
`;

export default TierBenefitsBottomSheet;
